var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._g({tag:"component",style:(_vm.style)},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }